import { Control, FieldValues, useController, UseFormSetValue } from "react-hook-form";
import { Route } from "../../../models/route";
import ListRoutesPage from "../../../pages/organization/routes/ListRoutesPage";
import ReadOnlyInputBox from "../../InputBox/ReadonlyInputBox";
import { EntityDetailsDisplayInfoFieldReverseRoute, getValitationRules } from "../EntityDetailsDisplayInfo";
import { Button, Col, Row } from "react-bootstrap";
import { useAppSelector } from "../../../store/hooks";

interface EntityReverseRoutePickerProps<Entity extends FieldValues> {
    displayInfoInput: EntityDetailsDisplayInfoFieldReverseRoute<Entity>;
    setModalContent: React.Dispatch<React.SetStateAction<JSX.Element | null>>;
    control: Control<Entity, any>
    setValue: UseFormSetValue<Entity>
}

function EntityReverseRoutePicker<Entity extends FieldValues>({displayInfoInput, setModalContent, control, setValue}: EntityReverseRoutePickerProps<Entity>){

  const {
    field: { value, onChange, ref},
    fieldState,
    formState: { isSubmitting, isValid },
  } = useController({
    name: displayInfoInput.key,
    control,
    rules: getValitationRules(displayInfoInput),
  });

  const { allRoutes } = useAppSelector((state) => state.routes);

  const selectedRoute = allRoutes.find(r => r.id === value);
  const displayName = selectedRoute ? `${selectedRoute.name} (${selectedRoute.departure.name} - ${selectedRoute.destination.name})` : "";

  const updateRoute = (route: Route) => {
    onChange(route.id);
    setModalContent(null);
  }

  const clearRoute = () => {
    onChange(null);
  }

  const isDisabled = (isValid && isSubmitting) || (displayInfoInput.disabled ?? false)

  return (
    <Row>
      <Col xs={value ? 8 : 12} lg={value ? 9 : 12}>
        <ReadOnlyInputBox
          inputRef={ref!}
          value={displayName}
          isDisabled={isDisabled}
          name={displayInfoInput.name}
          fieldState={fieldState}
          onClick={() => {
            setModalContent(<ListRoutesPage onRouteSelected={updateRoute} />);
          }}
        />
      </Col>
      {value && (
        <Col xs={4} lg={3}>
          <Button disabled={isDisabled} variant="outline-dark" onClick={clearRoute} className="h-100 w-100">
            Clear
          </Button>
        </Col>
      )}
    </Row>
  );
}

export default EntityReverseRoutePicker
